import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/pages/home'
import LoginPage from '@/pages/login'
import RegisterPage from '@/pages/register'
import AgentRegisterPage from '@/pages/registerAgent'
import PassForgotPage from '@/pages/passForgot'
import PassResetPage from '@/pages/passReset'
import ConfirmEmailPage from '@/pages/confirmEmail'
import CheckInboxPage from '@/pages/checkInbox'
import LogoutUser from '@/pages/logoutAgent'
// dashboard
import DashboardPage from '@/pages/dashboard/dashboard'
import UserInvitePage from '@/pages/dashboard/userInvite'
import AccountDetailsPage from '@/pages/dashboard/accountDetails'
import UserYourFundsPage from '@/pages/dashboard/yourFunds'
// accountant
import TranchesPage from '@/pages/dashboard/tranches'
import MailsPage from '@/pages/dashboard/mails'
import ProcessLeadPage from '@/pages/dashboard/processLead'
// admin
import UsersPage from '@/pages/dashboard/users'

import { userHasAnyOfRoles, userHasRole } from '@/services/helper'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage
    },
    {
      path: '/logowanie',
      name: 'login',
      component: LoginPage
    },
    {
      path: '/rejestracja',
      name: 'register',
      component: RegisterPage
    },
    {
      path: '/rejestracja-agenta',
      name: 'registerAgent',
      component: AgentRegisterPage
    },
    {
      path: '/przypomnienie-hasla',
      name: 'passForgot',
      component: PassForgotPage
    },
    {
      path: '/potwierdz-email',
      name: 'confirmEmail',
      component: ConfirmEmailPage
    },
    {
      path: '/sprawdz-skrzynke',
      name: 'checkInbox',
      component: CheckInboxPage
    },
    {
      path: '/resetuj-haslo',
      name: 'passReset',
      component: PassResetPage
    },
    {
      path: '/konto',
      component: { template: '<router-view></router-view>' },
      children: [
        {
          path: 'wypelnij-dane',
          name: 'accountDetails',
          component: AccountDetailsPage,
          meta: { auth: true, allowRoles: ['unfilled_account_data'] }
        },
        {
          path: '',
          name: 'dashboard',
          component: DashboardPage,
          meta: { auth: true, disallowRoles: ['unfilled_account_data'] }
        },
        {
          path: 'narzedzia',
          name: 'tools',
          component: UserInvitePage,
          meta: { auth: true, disallowRoles: ['accountant', 'unfilled_account_data'] }
        },
        {
          path: 'twoje-srodki',
          name: 'yourFunds',
          component: UserYourFundsPage,
          meta: { auth: true, disallowRoles: ['accountant', 'agent'] }
        },
        {
          path: 'wyloguj-agenta',
          name: 'logoutAgent',
          component: LogoutUser
        },
        /* Accountant roles */
        {
          path: 'transze',
          name: 'tranches',
          component: TranchesPage,
          meta: { auth: true, allowRoles: ['accountant'] }
        },
        {
          path: 'maile',
          name: 'mails',
          component: MailsPage,
          meta: { auth: true, allowRoles: ['accountant'] }
        },
        {
          path: 'pelny-proces',
          name: 'completeProcess',
          component: ProcessLeadPage,
          meta: { auth: true, allowRoles: ['accountant'] }
        },
        {
          path: 'partnerzy',
          name: 'users',
          component: UsersPage,
          meta: { auth: true, allowRoles: ['admin'] }
        }
      ]
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  const userRoles = Vue.store.getters.getUserRoles
  if (to.meta.auth && !Vue.store.getters.isLoggedIn) {
    next({ name: 'login' })
  } else if (userHasRole(userRoles, 'unfilled_account_data') && (to.name !== 'accountDetails')) {
    next({ name: 'accountDetails' })
  } else if (userRoles && to.meta.allowRoles && !userHasAnyOfRoles(userRoles, to.meta.allowRoles)) {
    next({ name: 'dashboard' })
  } else if (userHasAnyOfRoles(userRoles, to.meta.disallowRoles)) {
    next(false)
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js